<template>
  <div class="forgot-page"><br />
    <!-- Background with animated gradient -->
    <div class="forgot-background">
      <div class="gradient-overlay"></div>
      <div class="floating-shapes">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
        <div class="shape shape-4"></div>
      </div>
    </div>

    <!-- Main Forgot Password Container -->
    <v-container class="forgot-container fill-height" fluid>
      <v-row justify="center" align="center" class="fill-height">
        <v-col cols="12" sm="11" md="10" lg="8" xl="7">
          <v-card class="forgot-card modern-card" elevation="24">
            <v-row no-gutters class="fill-height">
              <!-- Left Side - Branding -->
              <v-col cols="12" md="6" class="branding-section d-none d-md-flex">
                <div class="branding-content">
                  <div class="brand-header">
                    <div class="logo-container">
                      <v-icon class="brand-logo" size="60" color="white">mdi-lock-reset</v-icon>
                    </div>
                    <h2 class="brand-title">சார்லட் தமிழ்ச் சங்கம்</h2>
                    <h2 class="brand-subtitle">Charlotte Tamil Sangam</h2>
                  </div>

                  <div class="brand-description">
                    <p class="description-text">
                      Bringing together the vibrant Tamil community in Charlotte, promoting Tamil language, arts, and culture through unity and tradition.
                    </p>
                  </div>

                  <div class="brand-features">
                    <div class="feature-item">
                      <v-icon class="feature-icon" color="white">mdi-shield-check</v-icon>
                      <span class="feature-text">Secure & Safe</span>
                    </div>
                    <div class="feature-item">
                      <v-icon class="feature-icon" color="white">mdi-email-fast</v-icon>
                      <span class="feature-text">Quick Recovery</span>
                    </div>
                    <div class="feature-item">
                      <v-icon class="feature-icon" color="white">mdi-account-lock</v-icon>
                      <span class="feature-text">Account Protection</span>
                    </div>
                  </div>
                </div>
              </v-col>

              <!-- Right Side - Reset Password Form -->
              <v-col cols="12" md="6" class="form-section">
                <div class="form-container">
                  <!-- Header -->
                  <div class="form-header">
                    <div class="forgot-icon-container">
                      <img src="@/assets/cltts_logo.png" class="forgot-icon" alt="Reset Password"/>
                    </div>
                    <h2 class="form-title">Reset Password</h2>
                    <p class="form-subtitle">Enter your email to receive reset instructions</p>
                  </div>

                  <!-- Reset Password Form -->
                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="reset" class="forgot-form">
                    <!-- Email Field -->
                    <div class="input-group">
                      <v-text-field
                        v-model="email"
                        v-on:keyup="handleInputOnKeyup"
                        :rules="emailRules"
                        label="Email Address"
                        outlined
                        dense
                        class="modern-input"
                        type="email"
                        prepend-inner-icon="mdi-email-outline"
                        required
                        hide-details="auto"
                      ></v-text-field>
                    </div>

                    <!-- Reset Password Button -->
                    <v-btn
                      color="primary"
                      class="reset-btn"
                      large
                      block
                      elevation="8"
                      @click="reset"
                    >
                      <v-icon left>mdi-lock-reset</v-icon>
                      Send Reset Link
                    </v-btn>

                    <!-- Error Alert -->
                    <v-alert
                      v-if="popupError"
                      class="error-alert"
                      type="error"
                      dense
                      outlined
                      dismissible
                    >
                      Enter valid Email Id
                    </v-alert>

                    <!-- Success Alert -->
                    <v-alert
                      v-if="showMessage"
                      class="success-alert"
                      type="success"
                      dense
                      outlined
                      dismissible
                    >
                      Password Reset email sent. Check your inbox!
                    </v-alert>
                  </v-form>

                  <!-- Sign In Link -->
                  <div class="signin-section">
                    <p class="signin-text">
                      Remember your password?
                      <a href="#/Signin" class="signin-link">Sign In</a>
                    </p>
                  </div>

                  <!-- Sign Up Link -->
                  <div class="signup-section">
                    <p class="signup-text">
                      Don't have an account?
                      <a href="#/Signup" class="signup-link">Sign Up</a>
                    </p>
                  </div>

                  <!-- Social Login -->
                  <div class="social-section">
                    <v-divider class="social-divider"></v-divider>
                    <p class="social-text">Connect with us</p>
                    <div class="social-buttons">
                      <v-btn
                        class="social-btn facebook-btn"
                        href="https://www.facebook.com/cltts/"
                        target="_blank"
                        outlined
                        large
                      >
                        <v-icon left color="#1877F2">mdi-facebook</v-icon>
                        Facebook
                      </v-btn>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "ForgotPassword",
  data: () => ({
    valid: true,
    showMessage: false,
    popupError: false,
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+/.test(v) || 'E-mail must be valid'
    ]
  }),
  methods: {
    handleInputOnKeyup() {
      this.email = this.email.toLowerCase().trim()
    },
    signin() {
      this.$router.replace('/Signin')
    },
    reset() {
      if (!(this.email === null || this.email === '')) {
        this.popupError = false
        this.performingRequest = true
        const user = {
          email: this.email
        }
        this.$store.dispatch('sendPasswordResetEmail', user)
        setTimeout(() => {
          this.$router.replace('/Forgot')
          this.showMessage = true
        }, 200)
      } else {
        this.popupError = true
      }
    }
  }
}
</script>


<style lang="scss" scoped>
.forgot-page {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
}

/* Animated Background */
.forgot-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
  animation: gradientShift 8s ease-in-out infinite;
}

@keyframes gradientShift {
  0%, 100% {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
  }
  50% {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 50%, #4facfe 100%);
  }
}

/* Floating Shapes */
.floating-shapes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.shape {
  position: absolute;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
}

.shape-1 {
  width: 80px;
  height: 80px;
  top: 20%;
  left: 10%;
  animation-delay: 0s;
}

.shape-2 {
  width: 120px;
  height: 120px;
  top: 60%;
  right: 10%;
  animation-delay: 2s;
}

.shape-3 {
  width: 60px;
  height: 60px;
  bottom: 20%;
  left: 20%;
  animation-delay: 4s;
}

.shape-4 {
  width: 100px;
  height: 100px;
  top: 10%;
  right: 30%;
  animation-delay: 1s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

/* Main Container */
.forgot-container {
  position: relative;
  z-index: 1;
  padding: 20px;
}

/* Modern Card */
.forgot-card {
  border-radius: 20px !important;
  overflow: hidden !important;
  backdrop-filter: blur(20px) !important;
  background: rgba(255, 255, 255, 0.95) !important;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15) !important;
  min-height: 600px;
  max-width: 1000px !important;
  width: 100% !important;
  margin: 0 auto !important;
  animation: cardSlideIn 0.8s ease-out;
}

@keyframes cardSlideIn {
  from {
    opacity: 0;
    transform: translateY(50px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Branding Section */
.branding-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  position: relative;
  overflow: hidden;
}

.branding-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="50" cy="50" r="1" fill="rgba(255,255,255,0.1)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
  opacity: 0.3;
}

.branding-content {
  position: relative;
  z-index: 1;
  padding: 50px 40px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.brand-header {
  margin-bottom: 30px;
}

.logo-container {
  margin-bottom: 20px;
}

.brand-logo {
  background: rgba(255, 255, 255, 0.2) !important;
  border-radius: 50% !important;
  padding: 15px !important;
  backdrop-filter: blur(10px) !important;
  animation: logoFloat 3s ease-in-out infinite;
}

@keyframes logoFloat {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

.brand-title {
  font-size: 1.8rem !important;
  font-weight: 700 !important;
  color: white !important;
  margin-bottom: 8px !important;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.brand-subtitle {
  font-size: 1.2rem !important;
  font-weight: 400 !important;
  color: rgba(255, 255, 255, 0.9) !important;
  margin-bottom: 0 !important;
}

.brand-description {
  margin-bottom: 30px;
}

.description-text {
  font-size: 1rem !important;
  line-height: 1.6 !important;
  color: rgba(255, 255, 255, 0.8) !important;
  margin: 0 !important;
}

.brand-features {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.feature-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.1) !important;
  border-radius: 25px !important;
  backdrop-filter: blur(10px) !important;
  transition: all 0.3s ease !important;
}

.feature-item:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  transform: translateX(5px) !important;
}

.feature-icon {
  background: rgba(255, 255, 255, 0.2) !important;
  border-radius: 50% !important;
  padding: 6px !important;
}

.feature-text {
  font-size: 0.95rem !important;
  font-weight: 500 !important;
  color: white !important;
}

/* Form Section */
.form-section {
  background: white !important;
  display: flex !important;
  align-items: center !important;
}

.form-container {
  padding: 50px 40px;
  width: 100%;
  max-width: 450px;
  margin: 0 auto;
}

.form-header {
  text-align: center;
  margin-bottom: 30px;
}

.forgot-icon-container {
  margin-bottom: 20px;
}

.forgot-icon {
  width: 60px !important;
  height: 60px !important;
  border-radius: 50% !important;
  padding: 15px !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3) !important;
  animation: iconPulse 2s ease-in-out infinite;
}

@keyframes iconPulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 12px 35px rgba(102, 126, 234, 0.4);
  }
}

.form-title {
  font-size: 2rem !important;
  font-weight: 700 !important;
  color: #2d3748 !important;
  margin-bottom: 8px !important;
}

.form-subtitle {
  font-size: 1rem !important;
  color: #718096 !important;
  margin: 0 !important;
}

/* Forgot Form */
.forgot-form {
  margin-top: 30px;
}

.input-group {
  margin-bottom: 20px;
}

.modern-input {
  border-radius: 12px !important;
}

.modern-input .v-input__control .v-input__slot {
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

.modern-input .v-input__control .v-input__slot:hover {
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.1) !important;
}

.modern-input.v-input--is-focused .v-input__control .v-input__slot {
  border-color: #667eea !important;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2) !important;
}

/* Reset Button */
.reset-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
  border-radius: 12px !important;
  font-size: 1.1rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  margin-bottom: 20px !important;
  transition: all 0.3s ease !important;
}

.reset-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.4) !important;
}

.reset-btn:active {
  transform: translateY(0) !important;
}

/* Error Alert */
.error-alert {
  margin-top: 15px !important;
  border-radius: 8px !important;
}

/* Success Alert */
.success-alert {
  margin-top: 15px !important;
  border-radius: 8px !important;
}

/* Sign In Section */
.signin-section {
  text-align: center;
  margin: 20px 0;
}

.signin-text {
  font-size: 0.95rem !important;
  color: #718096 !important;
  margin: 0 !important;
}

.signin-link {
  color: #667eea !important;
  text-decoration: none !important;
  font-weight: 600 !important;
  transition: all 0.2s ease !important;
}

.signin-link:hover {
  color: #764ba2 !important;
  text-decoration: underline !important;
}

/* Sign Up Section */
.signup-section {
  text-align: center;
  margin: 15px 0;
}

.signup-text {
  font-size: 0.95rem !important;
  color: #718096 !important;
  margin: 0 !important;
}

.signup-link {
  color: #8ebf42 !important;
  text-decoration: none !important;
  font-weight: 600 !important;
  transition: all 0.2s ease !important;
}

.signup-link:hover {
  color: #667eea !important;
  text-decoration: underline !important;
}

/* Social Section */
.social-section {
  text-align: center;
  margin-top: 30px;
}

.social-divider {
  margin-bottom: 20px !important;
}

.social-text {
  font-size: 0.9rem !important;
  color: #718096 !important;
  margin-bottom: 15px !important;
}

.social-buttons {
  display: flex;
  justify-content: center;
}

.facebook-btn {
  border-color: #1877F2 !important;
  color: #1877F2 !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  transition: all 0.3s ease !important;
}

.facebook-btn:hover {
  background: #1877F2 !important;
  color: white !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 20px rgba(24, 119, 242, 0.3) !important;
}

/* Responsive Design */
@media (max-width: 960px) {
  .branding-section {
    display: none !important;
  }

  .form-container {
    padding: 30px 20px;
  }

  .form-title {
    font-size: 1.8rem !important;
  }

  .forgot-card {
    margin: 10px;
    min-height: auto;
  }
}

@media (max-width: 600px) {
  .forgot-container {
    padding: 10px;
  }

  .form-container {
    padding: 20px 15px;
  }

  .form-title {
    font-size: 1.6rem !important;
  }

  .reset-btn {
    font-size: 1rem !important;
  }
}
</style>
